(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const navigation = event.target.closest('.top-mobile-nav');
    if (navigation && event.target.closest('a')) navigation.open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.top-mobile-nav[open]').forEach((navigation) => {
      navigation.open = false;
      navigation.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
